import requestCommon from "@/components/web-interface/requestCommon";
const state = {
    exchanges: null
};
const actions = {
    getExchanges(context, data) {
        return requestCommon.getInfo(
            "/exchanges",
            null,
            null,
            context,
            "getExchangeDetailsSuccessHandler",
            "getExchangeDetailsErrorHandler"
        );
    }
}
const mutations = {
    getExchangeDetailsSuccessHandler(state, data) {
        state.exchanges = data.server.data;
    },
    getExchangeDetailsErrorHandler(context, error) {
        console.log(error);
    },
};
const getters = {};
export const exchangeStore = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}